import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card.tsx';
import { Button } from '../ui/button.tsx';
import { Info, Trash2 } from 'lucide-react';

interface AdminMember { 
    id: number; 
    Email: string; 
    FirstName: string; 
    LastName: string; 
    GraduationYear: number; 
    is_staff: boolean; 
    AssociationRole?: string; 
}

interface BoardTabProps {
    members: AdminMember[];
    handleRemoveFromBoard: (memberId: number) => Promise<void>;
}

export function BoardTab({ members, handleRemoveFromBoard }: BoardTabProps) {
    const activeBoardMembers = members.filter(m => 
        m.AssociationRole && 
        m.AssociationRole.trim() !== '' && 
        m.AssociationRole.trim().toLowerCase() !== 'üye' &&
        m.AssociationRole.trim().toLowerCase() !== 'uye' 
    );

    return (
        <Card>
            <CardHeader>
                <CardTitle>Yönetim Kurulu</CardTitle>
                <CardDescription>
                    Burada sadece "Dernekteki Görevi" atanmış üyeler listelenir. 
                    Yeni üye eklemek için "Üyeler" sekmesinden ilgili kişiye görev atayınız.
                </CardDescription>
            </CardHeader>
            <CardContent>
                {activeBoardMembers.length === 0 ? (
                    <div className="text-center py-10 bg-slate-50 rounded-lg text-slate-500">
                        <Info className="h-8 w-8 mx-auto mb-2 text-slate-400"/>
                        Yönetim kuruluna atanmış üye bulunamadı.
                    </div>
                ) : (
                    <div className="grid md:grid-cols-2 gap-4">
                        {activeBoardMembers.map(bm => (
                            <Card key={bm.id} className="shadow-sm">
                                <CardContent className="pt-4 flex justify-between items-center">
                                    <div className="flex items-center gap-3">
                                        <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-lg">
                                            {bm.FirstName[0]}{bm.LastName[0]}
                                        </div>
                                        <div>
                                            <div className="font-bold text-lg">
                                                {bm.FirstName} {bm.LastName}
                                            </div>
                                            <div className="text-blue-600 font-medium">
                                                {bm.AssociationRole}
                                            </div>
                                            <div className="text-xs text-slate-400">{bm.Email}</div>
                                        </div>
                                    </div>
                                    <Button 
                                        variant="ghost" 
                                        className="text-red-500 hover:text-red-700 hover:bg-red-50"
                                        onClick={() => handleRemoveFromBoard(bm.id)}
                                        title="Kuruldan Çıkar"
                                    >
                                        <Trash2 className="h-5 w-5"/>
                                    </Button>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
